<script>
export default {
  name: 'app-table-cell',
  props: {
    column: {
      default: null,
      type: Object
    },
    row: {
      default: null,
      type: Object
    },
    value: {
      default: null
    },
    first: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
    firstCell: {
      type: Boolean,
      default: false
    },
    imageCell: {
      type: Boolean,
      default: false
    }
  },

  render(createElement) {
    const { column, row, value, first, last, firstCell } = this

    const commonCellOptions = {
      class: {
        'first_data': first,
        'last_data': last,
        'no_padding_left': firstCell,
        'image': column.imageCell,
        'image image--icon': column.imageIcon
      },
      attrs: {
        'data-th': column ? column.label : ''
      }
    }

    if (!row) {
      return createElement('td', {
        ...commonCellOptions,
        domProps: {
          innerHTML: '<span class="placeholder" />'
        }
      })
    }

    if (column.template) {
      return createElement('td', { ...commonCellOptions }, column.template(row))
    }

    return createElement('td', {
      ...commonCellOptions,
      domProps: {
        innerHTML: value
      }
    })
  }
}
</script>
